// extracted by mini-css-extract-plugin
module.exports = {"WelcomeSection":"WelcomeSection_WelcomeSection__1cQGV"};